import React from 'react';
import Settings from '../../components/Settings';
import AppLayout from '../../layouts/AppLayout';
import './styles.css';

function SettingsPage() {
  return (
    <AppLayout title="Configurações" subtitle="Conta e preferências" fullWidth>
      <Settings />
    </AppLayout>
  );
}

export default SettingsPage;
